(() => {
  const sizeHeadingPattern = /^(fit\s*(?:&|and)\s*size|size\s*(?:&|and)\s*fit|size\s*guide|sizing)$/i;
  const sectionHeading = /^H[2-4]$/;

  function closeAccordions(root = document) {
    root.querySelectorAll('.product__info-container details[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  }

  function splitProductDetails(root = document) {
    root
      .querySelectorAll('[data-tsc-product-details]:not([data-tsc-ready])')
      .forEach((container) => {
        const source = container.querySelector('[data-tsc-product-source]');
        const descriptionTarget = container.querySelector('[data-tsc-product-description]');
        const sizeTarget = container.querySelector('[data-tsc-size-guide]');

        if (!source || !descriptionTarget || !sizeTarget) return;

        const content = document.createElement('div');
        content.innerHTML = source.innerHTML;

        const sizeHeading = Array.from(content.children).find((element) => {
          if (!sectionHeading.test(element.tagName)) return false;
          const heading = element.textContent.trim().replace(/\s+/g, ' ');
          return sizeHeadingPattern.test(heading);
        });

        if (sizeHeading) {
          let node = sizeHeading.nextElementSibling;
          const sizeNodes = [];

          while (node && !sectionHeading.test(node.tagName)) {
            const next = node.nextElementSibling;
            sizeNodes.push(node);
            node = next;
          }

          sizeHeading.remove();
          sizeNodes.forEach((element) => sizeTarget.append(element));
        }

        descriptionTarget.innerHTML = content.innerHTML;

        if (!sizeTarget.children.length) {
          sizeTarget.innerHTML =
            '<p>Review the available size options above. For personal sizing help, contact support@thesimpleco.shop before ordering.</p>';
        }

        source.remove();
        container.dataset.tscReady = 'true';
      });
  }

  function addSizeGuideTriggers(root = document) {
    const sizeDetails =
      root.querySelector('[data-tsc-product-details] details[id^="Details-size-guide"]') ||
      document.querySelector('[data-tsc-product-details] details[id^="Details-size-guide"]');

    if (!sizeDetails) return;

    root.querySelectorAll('.product__info-container .product-form__input').forEach((input) => {
      const label = input.querySelector('.form__label');
      if (!label || !/\bsize\b/i.test(label.textContent)) return;
      if (input.querySelector('.tsc-size-guide-trigger')) return;

      input.classList.add('tsc-has-size-guide');
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'tsc-size-guide-trigger';
      trigger.textContent = 'Size Guide';
      trigger.setAttribute('aria-controls', sizeDetails.id);

      trigger.addEventListener('click', () => {
        sizeDetails.open = true;
        sizeDetails.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => sizeDetails.querySelector('summary')?.focus(), 350);
      });

      label.after(trigger);
    });
  }

  function selectedPrice(info) {
    const price = info.querySelector(
      '[id^="price-"] .price__sale .price-item--sale, [id^="price-"] .price-item--regular'
    );
    return price?.textContent.trim().replace(/\s+/g, ' ') || '';
  }

  function setupMobileBar(root = document) {
    const info = root.querySelector('.product__info-container') ||
      document.querySelector('.product__info-container');

    if (!info || document.querySelector('[data-tsc-mobile-atc]')) return;

    const title = info.querySelector('.product__title h1')?.textContent.trim() || 'Selected item';
    const bar = document.createElement('div');
    bar.className = 'tsc-mobile-atc';
    bar.dataset.tscMobileAtc = '';
    bar.setAttribute('aria-live', 'polite');
    bar.innerHTML = `
      <div class="tsc-mobile-atc__meta">
        <span class="tsc-mobile-atc__title"></span>
        <strong class="tsc-mobile-atc__price"></strong>
      </div>
      <button class="button button--primary tsc-mobile-atc__button" type="button">Add to Cart</button>
    `;

    bar.querySelector('.tsc-mobile-atc__title').textContent = title;
    document.body.append(bar);
    document.body.classList.add('tsc-has-mobile-atc');

    const stickyButton = bar.querySelector('.tsc-mobile-atc__button');
    const stickyPrice = bar.querySelector('.tsc-mobile-atc__price');

    function currentButton() {
      return info.querySelector('.product-form__submit');
    }

    function sync() {
      const mainButton = currentButton();
      if (!mainButton) return;

      const label = mainButton.querySelector('span')?.textContent.trim().replace(/\s+/g, ' ') ||
        mainButton.textContent.trim().replace(/\s+/g, ' ') ||
        'Add to Cart';

      stickyButton.textContent = label;
      stickyButton.disabled = mainButton.disabled;
      stickyPrice.textContent = selectedPrice(info);
    }

    function updateVisibility() {
      const mainButton = currentButton();
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const hasPassedMainButton = mainButton && mainButton.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', Boolean(isMobile && hasPassedMainButton));
    }

    stickyButton.addEventListener('click', () => {
      const mainButton = currentButton();
      if (!mainButton || mainButton.disabled) {
        info.querySelector('.product-form__input')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        return;
      }
      mainButton.click();
    });

    new MutationObserver(() => {
      sync();
      updateVisibility();
    }).observe(info, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    sync();
    updateVisibility();
  }

  function init(root = document) {
    splitProductDetails(root);
    closeAccordions(root);
    addSizeGuideTriggers(root);
    setupMobileBar(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:reorder', () => closeAccordions());
})();
